
import { defineComponent, SetupContext } from "vue";
import SearchTagItem from "./SearchTagItem.vue";
import { getTagName } from "@/utils/search-util";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "SearchTagList",
  components: { SearchTagItem },
  props: {
    /**
     * タグの種類を定義
     */
    alias: {
      type: String,
      required: true
    },
    /**
     * タイトル
     */
    title: {
      type: String,
      required: true
    },
    /**
     * タグを表示するデータ配列
     */
    tags: {
      type: Array,
      default: () => []
    },
    selectedTags: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("SearchTagList setup title=" + props.title + " tags=" + JSON.stringify(props.tags));
    /**
     * レシピ押下時に id と type を通知する
     *
     * @param {number} id - レシピID
     * @param {string} type - レシピの種別
     */
    const selectRecipe = (id: number, type: string) => {
      context.emit("on-click", id, type);
    };

    /**
     * タグ押下時に type と tag を通知する
     *
     * @param {string} alias - タグの種別
     * @param {string} id - タグ名
     */
    const selectTag = (alias: string, id: number) => {
      context.emit("select-tag", alias, id);
    };

    const isActive = (id: number) => {
      const result = props.selectedTags.includes(id);
      NativeClient.sendDebugLog("SearchTagList isActive result=" + result + " selectedTags=" + props.selectedTags + " id" + id);
      return result;
    }

    return {
      selectRecipe,
      selectTag,
      getTagName,
      isActive
    };
  }
});
